import React from "react";
import {Field} from "formik";
import {Fields} from "../../../../uicomponents";
import "./form.scss";
import {get} from "lodash";

const Form = ({values, setStatusCheck}) => {
    return (
        <>
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            <Field
                component={Fields.SelectS1}
                name="status"
                placeholder="Введите статус"
                label={"Статус"}
                size={"small"}
                options={[
                    {value: 1, label: "Новые"},
                    {value: 2, label: "В процессе"},
                    {value: 10, label: "Завершенный"},
                    {value: 11, label: "Отсроченный"},
                    {value: 12, label: "Продленный"},
                    {value: 20, label: "Отменено"},
                ]}
                handleChange={(e) => {
                    setStatusCheck(e.value);
                }}
                optionValue={"value"}
                optionLabel={"label"}
                className="input select"
                styles={{
                    menuList: (base) => ({
                        ...base,
                        maxHeight: "120px",
                        overflowY: "auto",
                    }),
                }}
            />
            <Field
                component={Fields.InputS1}
                name="content"
                type="text"
                size={"small"}
                placeholder="Введите content"
                label={"Content"}
                className="input"
            />
            {values.status === 12 && (
                <Field
                    component={Fields.NewDatePicker}
                    name="scheduled_time"
                    placeholder="Дедлайн"
                    format="dd.MM.yyyy"
                    label={"Дедлайн"}
                    className="date-picker"
                />
            )}
        </>
    );
};

export default Form;
